<template>
  <div class="tabs">
    <span class="titles">当前位置：</span>
    <div class="tablist">
      <span v-for="(item, index) in tablist" :key="index"  @click="tolist(item.id)">
        {{ item.name }}
        <span v-if="index < tablist.length - 1">></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  data() {
    return {
      categoryid: "",
      postid: "",
      tablist: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    // this.gettablist();
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newVal, oldVal) {
        this.categoryid = newVal.categoryid;
        // this.postid = newVal.postid;
        this.gettablist();
      }
    }
  },
  methods: {
    tolist(id) {
      if(id == 0){
        this.$router.push({ name: "index" });
        return;
      }
      this.$router.push({ name: "list", query: { categoryid: id } });
    },
    gettablist(id) {
      this.$api.post({
        url: "categories/categoryUp",
        data: {
          category_id: this.categoryid,
          post_id: this.postid
        },
        success: (res) => {
          // console.log(res);
          this.tablist = res.data;
        }
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">


.tablist span:hover{
  color: #b80808;
  font-weight: bold !important;
}

@media all and (max-width: 1200px) {
  .tabs {
    width: 95% !important;
    margin: 0 auto;
    height: 30px !important;
    font-size: 12px !important;
    .titles {
      font-size: 10px !important;
    }
  }
}
.tabs {
  display: flex;
  align-items: center;
  width: 1170px;
  margin: 0 auto;
  height: 40px;
  background: #f9ddc8;
  border-top: 1px solid #c5090b;
  border-bottom: 1px solid #c5090b;
  padding-left: 20px;
  color: #000;
  font-size: 16px;
  span{
    cursor:pointer;
  }
  .titles {
    font-size: 14px;
  }
}
</style>
